export const ImageCaret = () => {
	return (
		<svg height="24" width="24" viewBox="0 0 24 24">
			<path d="M7.41 8.29492L12 12.8749L16.59 8.29492L18 9.70492L12 15.7049L6 9.70492L7.41 8.29492Z" />
		</svg>
	);
};
